import * as React from 'react';
import { styled } from 'linaria/react';
import { Switch } from '@sevone/scratch';
import {
  DatasourceSelector,
  FlowViewSelector,
  FlowViewType
} from '@sevone/insight-connect';
import { VERTICAL_RHYTHM } from '../../../../../../utils/spacing';
import { ConfigureVariableProps } from '../../types';
import { ConfigurationType, OptionType, ValueType } from './types';

const Wrapper = styled.div``;

const SwitchWrapper = styled.div`
  display: flex;
  margin-bottom: ${VERTICAL_RHYTHM}px;
`;

const ControlWrapper = styled.div`
  margin-bottom: ${VERTICAL_RHYTHM}px;
`;

type Props = ConfigureVariableProps<ConfigurationType, OptionType, ValueType>;

function Configure(props: Props) {
  const { config, options, onConfigChange, onOptionsChange } = props;

  const handleSelectAllChange = (checked: boolean) => {
    onConfigChange({ selectAll: checked });
  };

  const handleAggregationChange = (aggregated: boolean) => {
    onConfigChange({ isAggregated: aggregated });
    onOptionsChange([]);
  };

  const handleClearableChange = (checked: boolean) => {
    onConfigChange({ isClearable: checked });
  };

  const handleDatasourceChange = (datasources: Array<number>) => {
    onConfigChange({ datasources });
  };

  const handleFlowViewChange = (views: Array<FlowViewType>) => {
    onOptionsChange(views);
  };

  return (
    <Wrapper>
      <SwitchWrapper>
        <Switch checked={config.isClearable} onChange={handleClearableChange}>
          {'Clear selection'}
        </Switch>
      </SwitchWrapper>
      <SwitchWrapper>
        <Switch checked={config.selectAll} onChange={handleSelectAllChange}>
          {'Select all'}
        </Switch>
      </SwitchWrapper>
      <SwitchWrapper>
        <Switch checked={config.isAggregated} onChange={handleAggregationChange}>
          {'Aggregated data (view selection will be cleared)'}
        </Switch>
      </SwitchWrapper>
      <ControlWrapper>
        <DatasourceSelector
          isMulti
          label="Datasources"
          value={config.datasources}
          onChange={handleDatasourceChange}
        />
      </ControlWrapper>
      {!config.selectAll &&
        <ControlWrapper>
          <FlowViewSelector
            // TODO: Remove once cache is cleared on `isAggregated` changes
            key={config.isAggregated ? 'aggregated' : 'notAggregated'}
            label="Flow Views"
            isAggregated={config.isAggregated}
            datasources={config.datasources}
            value={options}
            onChange={handleFlowViewChange}
          />
        </ControlWrapper>
      }
    </Wrapper>
  );
}

export { Configure };
